let instance = null;

/**
 * Check the background color and add .white-text or .black-text to
 * the section and then change color text
 * @class
 */
class _textColorCheck {
  constructor() {
    // implement singleton design pattern
    if (instance) {
      return instance;
    }
    instance = this;
  }

  _checkBackground($el) {
    let hexcolor = $el.data('bg-color');

    if (!hexcolor) return;

    // If a leading # is provided, remove it
    if (hexcolor.slice(0, 1) === '#') {
      hexcolor = hexcolor.slice(1);
    }

    // If a three-character hexcode, make six-character
    if (hexcolor.length === 3) {
      hexcolor += hexcolor;
    }

    // Convert to RGB value
    const r = parseInt(hexcolor.substr(0, 2), 16);
    const g = parseInt(hexcolor.substr(2, 2), 16);
    const b = parseInt(hexcolor.substr(4, 2), 16);

    // Get YIQ ratio
    const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

    // Check contrast
    $el.addClass((yiq >= 128) ? 'black-text' : 'white-text');
  }
}

export const TextColorCheck = new _textColorCheck();
